import { useCallback, useEffect } from 'react'
import { areCommonFiltersValid } from '@signals/commonFilters/filters'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { isLoadingCommonFilters } from '@signals'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@hooks'
import { isSearching, clearSignals, realTimeFilters, idSearch } from 'Pages/RealTimeHistory/RealTime/@signals'


export default function useRealTimeFilters() {
	const navigate = useNavigate()
	const { showToast } = useToast()

	const handleSubmit = useCallback(() => {
		if (areCommonFiltersValid.value) {
			clearSignals()
			postSubmit(`${BACKEND_APIS.SEARCH}/manual/launch-async`, realTimeFilters.value).then(({ searchID }) => {
				if (searchID) {
					idSearch.value = searchID
					navigate(`/real-time/searches?idSearch=${searchID}` , { replace: true })
					isSearching.value = true
				}
				isLoadingCommonFilters.value = false
			}).catch(() => {
				isLoadingCommonFilters.value = false
				showToast.error('Search failed, please try again.')
			})
		}
	}, [JSON.stringify(realTimeFilters.value)])

	useEffect(() => {
		if(isLoadingCommonFilters.value) handleSubmit()
	}, [isLoadingCommonFilters.value])


}